import image_ilustration from './image-ilustration.png'
import logo from './logo.png'
import logo_text from './logo-text.png'
import icon_instagram from './icon-instagram.svg'
import icon_linkedin from './icon-linkedin.svg'
import dummy_logo_company from './dummy-logo-company.png'
import dummy_profile_image from './dummy-profile-image.png'
import hamburger from './hamburger.png'
import profie from './profile.png'

export const image = {
  image_ilustration: image_ilustration,
  logo: logo,
  logo_text: logo_text,
  icon_instagram: icon_instagram,
  icon_linkedin: icon_linkedin,
  dummy_logo_company: dummy_logo_company,
  dummy_profile_image: dummy_profile_image,
  hamburger: hamburger,
  profie: profie
}
